import React, {useEffect, useState} from 'react';
import './TableDetailCoding.scss';
import _axios from "../../../../httpService";
import {toast} from "react-toastify";
import SelectedFromTable from "./SelectedFromTable/SelectedFromTable";
import DynaTable from "../../../MyTable/DynaTable";
import Loader from "../../../Loader";
import TableDataChangerVTwo from "./TableDataChanger/TableDataChangerVTwo";

const TableDetailCoding = () => {

  const prefixUrl = localStorage.getItem("apiUrl");
  const [initialData, setInitialData] = useState({});
  const [componentData, setComponentData] = useState({});
  const [currentRowData, setCurrentRowData] = useState({});
  const [floatingData, setFloatingData] = useState({
    accountTitle: "",
    floatingAccountsList: [],
    isLoading: false,
    floatingAccountCode: ""
  })
  const [initialDataManage, setInitialDataManage] = useState(0)
  const [isLoad, setIsLoad] = useState(false)
  const [filterData, setFilterData] = useState({
    hasFilter: false,
    level: 1,
    value: 10,
    label: "10 - موجودی نقد و بانک"
  })
  const [loadTable, setLoadTable] = useState(true)

  useEffect(() => {
    setLoadTable(false)
    _axios.get(prefixUrl + "/accountingAccounts/?request=accountsList&filter=" + JSON.stringify(filterData))
      .then((response) => {
        if (response.data.status) {
          setInitialData(response.data)
          setIsLoad(true)
          setLoadTable(true)
        } else {
          toast.error(response.data.message)
        }
      })
  }, [initialDataManage, filterData])

  const rowClickHandler = (rowData) => {

    setFloatingData({...floatingData, isLoading: true})
    setCurrentRowData(rowData)

    // در خواست برای نمایش جدول شناور
    {/*
      _axios.get(prefixUrl + "/accountingAccounts/?request=floatingAccountsList&id=" + rowData.id)
        .then(response => {
          const data = response.data;
          if (response.data.status) {

            console.log(response.data)
            const temp = {...floatingData}
            temp.isLoading = false;
            temp.floatingAccountCode = rowData.id;
            temp.floatingAccountsList = data.floatingAccountsList;
            temp.rowId = rowData.id;
            setFloatingData(temp)
          } else {
            toast.error(response.data.message)
          }
        })
   */
    }
  }
  let addHandler = (value, id, floatingAccountCode) => {

    _axios.post(prefixUrl + "/accountingAccounts/", {
        request: "newFloatingAccount",
        data: {id: floatingAccountCode, floatingAccountTitle: value}
      }
    )
      .then(res => {

        if (res.data.status) {
          rowClickHandler(floatingData.rowId, floatingData.accountTitle)
          toast.success(res.data.message)
        } else {
          toast.error(res.data.message)

        }

      })
  };

  const editHandler = (id, floatingAccountTitle, floatingAccountCode) => {

    _axios.put(prefixUrl + "/accountingAccounts/", {
        request: "editFloatingAccount",
        data: {
          id: id,
          floatingAccountTitle: floatingAccountTitle,
          floatingAccountCode: floatingAccountCode
        }
      }
    )
      .then(res => {
        if (res.data.status) {
          rowClickHandler(floatingData.rowId, floatingData.accountTitle)
          toast.success(res.data.message)
        } else {
          toast.error(res.data.message)
        }

      })
  };

  const deleteHandler = (id) => {
    _axios.delete(prefixUrl + "/accountingAccounts/", {
        data: {
          request: "deleteFloatingAccount",
          floatingAccountCode: id
        }
      }
    )
      .then(res => {
        if (res.data.status) {
          rowClickHandler(floatingData.rowId, floatingData.accountTitle)
          toast.success(res.data.message)
        }
      })
  }

  return (

    <div className={'py-2 px-4'}
         style={{'width': '100%', margin: '0 auto', 'height': '100vh', 'overflow': 'scroll',}}>

      {isLoad ?
        <div className="main-detail-table">

          {Object.keys(initialData).length > 0 &&
            <TableDataChangerVTwo initialData={initialData}
                                  setComponentData={setComponentData}
                                  componentData={componentData}
                                  currentRowData={currentRowData}
                                  setCurrentRowData={setCurrentRowData}
                                  setFilterData={setFilterData}
                                  loadTable={loadTable}
                                  setInitialDataManage={setInitialDataManage}/>
          }

          {loadTable ?
            Object.keys(componentData).length > 0 &&
            <div className="table-side">
              <DynaTable
                column={componentData?.column}
                data={componentData?.data}
                className={"solid-table"}
                priceFields={initialData?.priceFields}
                onRowClick={rowClickHandler}
                mainWidth={'100%'}/>
            </div> : <Loader/>
          }

          {Object.keys(floatingData.floatingAccountsList).length > 0 &&
            <SelectedFromTable floatingData={floatingData}
                               editHandler={editHandler}
                               deleteHandler={deleteHandler}
                               addHandler={addHandler}/>
          }

        </div>
        : <Loader/>}


    </div>
  );
};
export default TableDetailCoding;